<script>
export default {
  name: "PriceComponent",
  props: {
    objectPrice: {
      type: Number,
      required: true
    },
    objectPriceSale: {
      type: Number,
      required: true
    },
    reportType: {
      type: Number,
      required: true
    },
    paperReportPrice: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="price">
    <template v-if="!objectPriceSale">
      <span>{{ objectPrice }} руб.</span>
    </template>
    <template v-else>
      <span class="price_sale">{{ objectPrice }} руб.</span>
      <span>{{ objectPriceSale }} руб.</span>
    </template>
    <p v-if="reportType === 2">+{{ paperReportPrice }} руб.</p>
  </div>
</template>

<style scoped>

.price {
  display: inline-block;
  vertical-align: middle;
  width: 55%;
  text-align: center;
}

.price_sale {
  color: red;
  text-decoration: line-through;
  margin-right: 5px;
}

</style>
